<script setup lang="ts"></script>

<template>
	<li class="menu-title">
		<slot />
	</li>
</template>
